/**
 * Helpers for rooms taken out of sale by a maintenance request.
 *
 * The dashboard calendar returns `maintenance_blocks` per room as date ranges, while
 * the allocation/check-in/all-rooms endpoints return a resolved `is_maintenance_blocked`
 * flag for the stay they were asked about.
 */

/** True when the room is out of sale on the given YYYY-MM-DD date. */
export function isRoomMaintenanceBlockedOn(room, dateStr) {
  if (!room || !dateStr) return false;
  const blocks = room.maintenance_blocks;
  if (!Array.isArray(blocks) || blocks.length === 0) {
    return Boolean(room.is_maintenance_blocked);
  }
  return blocks.some(
    (block) => block?.start_date <= dateStr && block?.end_date >= dateStr,
  );
}

/** The block covering the given date, for tooltips. */
export function getRoomMaintenanceBlockOn(room, dateStr) {
  if (!room || !dateStr) return null;
  const blocks = Array.isArray(room.maintenance_blocks) ? room.maintenance_blocks : [];
  return (
    blocks.find((block) => block?.start_date <= dateStr && block?.end_date >= dateStr) || null
  );
}

/** Short reason shown on hover for a blocked room cell. */
export function getRoomMaintenanceBlockLabel(room, dateStr) {
  const block = getRoomMaintenanceBlockOn(room, dateStr);
  if (!block) {
    return room?.is_maintenance_blocked ? 'Blocked for maintenance' : '';
  }
  const issue = block.issue_type ? ` — ${block.issue_type}` : '';
  return `Blocked for maintenance${issue} (${block.start_date} to ${block.end_date})`;
}
